<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-card border-variant="light" class="card-doc">
                <b-card-title class="text-dark font-20 font-weight-bold"
                    ><b-row>
                        <b-col> Danh sách lịch sử các trận lũ </b-col>
                        <b-col class="d-flex content-action align-items-center">
                            <div
                                class="input-group border-bottom position-relative"
                                style="width: 190px"
                            >
                                <input
                                    class="form-control bg-transparent border-none pr-4"
                                    :placeholder="$t('common.search')"
                                    aria-label="Search"
                                    v-model="searchKeyword"
                                    style="min-width: 190px"
                                />
                                <i
                                    class="fa fa-search position-absolute"
                                    style="top: 50%; right: 4px; margin-top: -6px"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </b-card-title>
                <b-table
                    class="mt-2"
                    striped
                    hover
                    :items="listThunderDataDisplay"
                    :fields="fields"
                    show-empty
                    :current-page="currentPage"
                    :per-page="5"
                    :filter="searchKeyword"
                    :filter-included-fields="['time']"
                    @filtered="onFiltered"
                >
                    <template #cell(index)="data">{{
                        (currentPage - 1) * 5 + (data.index + 1)
                    }}</template>
                    <template v-slot:empty>
                        <div class="text-center">
                            <span>Không có bản ghi nào</span>
                        </div>
                    </template>
                </b-table>
                <div v-if="totalRows > 5" class="my-1">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="5"
                        :hide-goto-end-buttons="true"
                        :prev-text="$t('common.prevPage')"
                        :next-text="$t('common.nextPage')"
                        class="my-0"
                        align="center"
                        first-number
                        last-number
                    />
                </div>
            </b-card>
            <FloodMap />
            <b-card border-variant="light" class="card-doc">
                <b-card-title class="text-dark font-20 font-weight-bold"
                    ><b-row>
                        <b-col>Thống kê mực nước trung bình các trạm theo tháng</b-col>
                        <b-col class="text-right">
                            <span style="font-size: 16px">Chọn tháng: </span>
                            <RDateTimePicker
                                :value="$moment(new Date(), 'MM/YYYY')"
                                @updateValue="onChangeMonth"
                                :type="'month'"
                            />
                        </b-col>
                    </b-row>
                </b-card-title>
                <LineChartAnalyzeWaterHigh />
                <hr />
                <ListAssetDamage />
                <hr />
                <ListPersonDamage />
            </b-card>
        </div>
    </div>
</template>

<script>
import FloodMap from '@/components/FloodMap';
import ListAssetDamage from '@/components/ListAssetDamage';
import ListPersonDamage from '@/components/ListPersonDamage';
import LineChartAnalyzeWaterHigh from '@/components/LineChartAnalyzeWaterHigh';
import RDateTimePicker from '@/components/RDateTimePicker';
import { mapActions } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    components: {
        FloodMap,
        ListAssetDamage,
        ListPersonDamage,
        LineChartAnalyzeWaterHigh,
        RDateTimePicker
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    key: 'time',
                    label: 'Tên trận lũ'
                }
            ],
            listThunderData: [],
            CONSTANTS,
            currentPage: 1,
            searchKeyword: '',
            totalRows: 0
        };
    },
    computed: {
        listThunderDataDisplay() {
            let listData = this.listThunderData;
            listData = listData.map((item) => {
                return {
                    ...item,
                    time: `Trận lũ ngày ${this.$moment(item.time).format('DD/MM/YYYY')}`
                };
            });
            return listData;
        }
    },
    methods: {
        ...mapActions({
            getListDamage: 'analyze/getListDamage',
            getListStation: 'station/getList',
            getListGeoJson: 'geojson/getList',
            getWaterReportByMonth: 'analyze/getWaterReportByMonth'
        }),
        onChangeMonth(data) {
            let monthSelect = this.$moment(data).format('MM/YYYY');
            this.getWaterReportByMonth({ month: monthSelect });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
        }
    },
    async created() {
        this.listThunderData = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER
        });
        this.getListStation();
        this.getListDamage();
        this.getWaterReportByMonth({ month: this.$moment().format('MM/YYYY') });
        this.totalRows = this.listThunderDataDisplay.length;
    }
};
</script>
